export default "__VITE_ASSET__8cbc6695__"